export default "__VITE_ASSET__DiN1uPWF__"